import Svg, { Path } from 'react-native-svg';
import Colors from 'src/core/utils/Colors';
import Dimens from 'src/core/utils/Dimens';

interface Props {
	width?: number;
	height?: number;
}

export default ({ width = Dimens.iconSize30, height = Dimens.iconSize30 }: Props) => (
	<Svg height={height} viewBox="0 0 25.079 23.974" width={width}>
		<Path
			d="m12.307 19.743-6.512 3.423a.5.5 0 0 1-.726-.527l1.244-7.25a.5.5 0 0 0-.144-.443L.901 9.81a.5.5 0 0 1 .277-.852L8.458 7.9a.5.5 0 0 0 .377-.274l3.256-6.597a.5.5 0 0 1 .897 0l3.256 6.597a.5.5 0 0 0 .376.274l7.28 1.058a.5.5 0 0 1 .278.852l-5.269 5.136a.5.5 0 0 0-.143.442l1.243 7.251a.5.5 0 0 1-.725.527l-6.512-3.423a.5.5 0 0 0-.465 0Z"
			fill="none"
			fillRule="evenodd"
			stroke={Colors.gray75}
			strokeWidth="1.5"
		/>
	</Svg>
);
